import makeDebug from "debug";
import { toPairs } from "lodash";
import { getEnvironment } from "./environment";

const debug = makeDebug("liveChat");

/* INITIALZE HELPSCOUT */

export function initLiveChat() {
	window.addEventListener("cc:onConsent", ({ detail }) => {
		if (!detail.cookie.categories.includes("help")) {
			return;
		}
		if (getEnvironment() === "development") {
			console.log("Skipping live chat in development");
			return;
		}
		window.$crisp = [];
		window.CRISP_WEBSITE_ID = "dbaa2cd5-3f5e-4006-9695-7f73e01579c7";
		(() => {
			const d = document;
			const s = d.createElement("script");
			s.src = "https://client.crisp.chat/l.js";
			s.async = 1;
			d.getElementsByTagName("head")[0].appendChild(s);
		})();
		window.$crisp.push(["safe", true]);
		window.$crisp.push(["set", "session:segments", [["app_portal"]]]);
	});
}

/* IN APP FUNCTIONS */
export const showLiveChatNewMessage = (_user) => {
	debug("open live chat new message");
	if (!window.$crisp?.is) {
		console.error("crisp not set");
		window.open("https://help.kultify.com");
		return;
	}
	window.$crisp.push(["do", "chat:open"]);
};

/* IN APP FUNCTIONS */

export const authenticateUserWithLiveChat = (user) => {
	if (!window.$crisp) {
		return;
	}
	const data = {
		name: `${user.profile.given_name} ${user.profile.family_name}`,
		email: user.profile.email,
		userId: user.profile.sub,
	};
	debug("Auth user", data);
	window.$crisp.push(["set", "session:data", [toPairs(data)]]);
	window.$crisp.push(["set", "user:email", [data.email]]);
	window.$crisp.push(["set", "user:nickname", [data.name]]);
};
